

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home , Login , Register,Dashboard, Header,PrivateRoute,ForgetPassowrd, ResetPassword} from './components';


function App() {
  return (
 <>

 <Router>
 <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/Forget-Password" element={<ForgetPassowrd />} />
           <Route path="/reset-password/:token" element={<ResetPassword />} />
           <Route path="*" element={<h1>Page Not Found</h1>} />
          <Route 
            path="/dashboard" 
            element={
           
              <PrivateRoute>
              <Dashboard />
              </PrivateRoute>
             
            } 
          />
        </Routes>
    </Router>
 </>
  );
}

export default App;